import { ReactNode } from "react";
import { Context } from "./context";
import { useSelectedGroupState } from "./use-selected-group-state";

export function SelectedGroupProvider({ children }: { children: ReactNode }) {
  const { selectedGroup, setSelectedGroup } = useSelectedGroupState();

  return (
    <Context.Provider
      value={{
        selectedGroup,
        setSelectedGroup,
      }}
    >
      {children}
    </Context.Provider>
  );
}
